function getCookie(cname) {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export const bookmarkModule = {
  state: {
    bookmarks: [],
    selectedPages: [],
  },

  actions: {
    toggleBookmark(context, payload) {
      if (context.getters.bookmarks.includes(payload)) {
        context.commit('removeBookmark', payload);
      } else {
        context.commit('addBookmark', payload);
      }

      document.cookie = `bookmarks=${context.getters.bookmarks.join(',')};path=/`;

      // Notify other tabs/windows about bookmark state change
      localStorage.setItem('event', 'onBookmarkChange');
      localStorage.removeItem('event');
    },
    loadBookmarksFromCookie(context) {
      const bookmarkCookie = getCookie('bookmarks');

      if (!bookmarkCookie) {
        return;
      }

      const pageUids = bookmarkCookie
        .split(',')
        .map(bm => parseInt(bm));

      context.commit('updateBookmarks', pageUids);
    },
  },

  mutations: {
    addBookmark(state, payload) {
      state.bookmarks.push(payload);
    },
    removeBookmark(state, payload) {
      state.bookmarks = state.bookmarks.filter(bm => bm !== payload);
    },
    updateBookmarks(state, payload) {
      state.bookmarks = payload;
    },
    selectPage(state, payload) {
      state.selectedPages.push(payload);
    },
    deselectPage(state, payload) {
      state.selectedPages = state.selectedPages.filter(p => p !== payload);
    },
    updateSelectedPages(state, payload) {
      state.selectedPages = payload;
    },
    clearPages(state) {
      state.selectedPages = [];
    }
  },

  getters: {
    bookmarks: state => state.bookmarks,
    selectedPages: state => state.selectedPages,
  },
};
